var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parentMessageBox"},[_c('div',{staticClass:"content"},[_c('parentMessage',{attrs:{"form":_vm.form}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }